export default [
  {
    title: `Offline First Mobile App`,
    description: `Don't depend on Connectivity. Being Offline Enabled ensures you'll capture every detail in the field.`,
    icon: 'offlineFirst'
  },
  {
    title: `Walkthroughs on the Fly`,
    description: `Create and schedule Walkthroughs with just a few clicks anytime, anywhere.`,
    icon: 'mobileApp'
  },
  {
    title: `Crystal Clear Notes`,
    description: `Create a perfect portrait of your client's building by capturing every detail.`,
    icon: 'crystalClearNotes'
  },
  {
    title: `Simple One-Click Sharing`,
    description: `Review clean and organized Walkthrough data from any device. Export it to PDF to easily share with your team or client.`,
    icon: 'oneClickSharing'
  }
]
